export function postMessage (data, target = '*', stringify = true) {
  if ((navigator.userAgent.match(/(iPhone|iPod|iPad);?/i))) {
    if (stringify) {
      const { type, ...params } = data
      // window.webkit.messageHandlers[type].postMessage(params)
      window.webkit.messageHandlers[type].postMessage(params)
    } else {
      window.webkit.messageHandlers[data].postMessage()
    }
  } else {
    let message = stringify ? JSON.stringify(data) : data
    console.group('postMessage')
    console.log('stringify', stringify)
    console.log('target', target)
    console.log(message)
    console.groupEnd()
    window.postMessage(message, target)
  }
}

export function listenMessage (callback, parse = true) {
  function Listener (event) {
    let message = event['data']
    if (typeof message === 'string' && parse) {
      message = JSON.parse(message)
    } else {
      // 处理react-devtools-bridge"
      return
    }
    console.group('listenMessage')
    console.log(event['origin'])
    console.log(message)
    console.log(event)
    console.groupEnd()
    callback && callback(message)
  }

  window.addEventListener('message', Listener)
  return Listener
}
